import Vue from 'vue'
import moment from 'moment'

// 时间处理
Vue.filter('timeCustomize', function (data, formatString) {
    if (data) {
        return moment(data).format(formatString)
    }
    return data;
});

// 时间处理1
Vue.filter('getStringFirst', function (data) {
    if (data) {
        let _array = data.split('');
        return _array[0].toUpperCase()
    }
    return data;
});

// 千分位
Vue.filter('thousandFormatNumber', function (num) {
    if (num) {
        if(num>0) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else {
            let _num= Math.abs(num);
            return '('+_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+')';
        }
    }
    return num || 0;
});

// 时间处理1
Vue.filter('convertToExcelColumn', function (num) {
    let result = "";
    while (num > 0) {
        num--; // 因为Excel列是从1开始的，而我们使用的是从0开始的ASCII码，所以需要减1
        const remainder = num % 26;
        result = String.fromCharCode(65 + remainder) + result;
        num = Math.floor(num / 26);
    }
    return result;
});

//截取字符串第一个，并大写
Vue.filter('capitalizeFirstLetter', function (text) {
    let result = '';
    if (text) {
        result = text.toUpperCase().substring(0,1);
    }
    return result;
});

